import { onReadyEventMap } from '../comp.root.js';
import { PrinterState } from '../store.js';

function populatePrintTarget(key, target, input, onReady) {
  if (PrinterState.current?.contentKey === key) {
    onReady?.();
    return;
  }
  PrinterState.current = {
    contentKey: key,
    target: target,
    input: input
  };
  const hasTriggered = onReadyEventMap.get(key)?.triggered;
  if (hasTriggered) {
    onReady?.();
    return;
  }
  onReadyEventMap.clear();
  if (onReady) {
    onReadyEventMap.set(key, {
      triggered: false,
      cb: onReady
    });
  }
}

export { populatePrintTarget };
//# sourceMappingURL=_populate-print-target.js.map
